import "./bootstrap"
import "../css/app.css"
import "../css/post.css"
import "../css/carousel.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "primereact/resources/themes/tailwind-light/theme.css"
import "../css/fonts.css"

import { createRoot, hydrateRoot } from "react-dom/client"
import { createInertiaApp } from "@inertiajs/react"
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers"
import { configureEcho } from "@laravel/echo-react"
import { HelmetProvider } from "react-helmet-async"
import PrivacyGate from "@/Components/PrivacyGate/PrivacyGate"

configureEcho({
  broadcaster: "reverb",
})

createInertiaApp({
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.jsx`,
      import.meta.glob("./Pages/**/*.jsx")
    ),
  setup({ el, App, props }) {
    // PrivacyGate sits outside <App> so it covers every page regardless of
    // layout. It renders null until its client effect runs, so the initial
    // render still matches the SSR markup during hydration.
    const app = (
      <HelmetProvider>
        <App {...props} />
        <PrivacyGate />
      </HelmetProvider>
    )

    // SSR ships server-rendered markup, so hydrate it instead of mounting a
    // fresh tree. Mounting fresh (createRoot) re-runs Inertia's initial page
    // resolution over the SSR payload, which re-applies `Inertia::merge()`
    // props on top of the server copy and duplicates every merged item.
    if (el.hasChildNodes()) {
      hydrateRoot(el, app)
    } else {
      createRoot(el).render(app)
    }
  },
  progress: {
    color: "#4B5563",
  },
})
